<template>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Testdata.no</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0">
          <li v-for="menuElement in menuElements" :key="menuElement.name" class="nav-item">
            <a class="nav-link"
               :class="{ active: menuElement.active }"
               href="#"
               :id="menuElement.name"
               @click.prevent="linkPressed($event)">
              {{ menuElement.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'testdata-menu',
  props: ['menuElements'],
  data() {
    return {
      activePage: null
    }
  },
  methods: {
    setActive() {

    },
    linkPressed(event) {
      this.$emit('toggle-active-menu',event.target.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

